module.exports = __webpack_public_path__ + "kudos_23.svg?acaa519aae402104b11d6ce4ec2c05e6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_23.svg
// module id = 121
// module chunks = 0